// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__77pXU","colBig":"styles_colBig__1s6Ae","colSmall":"styles_colSmall__1ZtdK"};